function isMobile() {
    let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return flag;
}

$(function () {
    // // discount information不存在处理
    // if ($('.discount_information').children('ul').length > 0) {
    //     $(".ug-product-discount").addClass("discount_information_box");
    // } else {
    //     $(".discount_information").hide();
    // }
    // // bundles不存在处理
    // if ($('.ug-product-discount').length > 0) {
    //     $(".discount_information").addClass("discount_information_show");
    // } else {
    //     $(".discount_information").removeClass("discount_information_show");
    //     $(".discount_information ul").addClass("discount_information_ul_show");
    // }
    // // bundles预设空值处理
    // $(".discount_information li").each(function () {
    //     let discount_information_li = $(this).html();
    //     if (discount_information_li == null || discount_information_li.length == 0) {
    //         $(this).hide();
    //     } else {
    //         $(this).show();
    //     }
    // });
    $('.t4s-tab__title').on('click', function (event) {
        event.stopImmediatePropagation()
    })
    var t3Clipboard = new ClipboardJS('.ug-product-copy-btn');
    t3Clipboard.on('success', function (e) {
        $('.ug-product-copy-btn').hide()
        $('.ug-product-copy-btned').show()
        setTimeout(function () {
            $('.ug-product-copy-btn').show()
            $('.ug-product-copy-btned').hide()
        }, 3000)
        e.clearSelection();
    });
    var discountClipboard = new ClipboardJS('.ug-product-discount-btn');
    discountClipboard.on('success', function (e) {
        console.log(e.text);
        
        $(`.ug-product-discount-btn[data-clipboard-text='${e.text}']`).hide()
        $(`.ug-product-discount-btned[data-clipboard-text='${e.text}']`).show()
        setTimeout(function () {
            $(`.ug-product-discount-btn[data-clipboard-text='${e.text}']`).show()
            $(`.ug-product-discount-btned[data-clipboard-text='${e.text}']`).hide()
        }, 3000)
        e.clearSelection();
    });
    // $('.t4s-product-form__variants').before($('.ug-product-discount').clone())
    // $('.t4s-pr__custom-liquid .ug-product-discount').remove()

    // school
    new ClipboardJS('.ug-school-discount-box button');
    $('.ug-school-discount-box button').click(function () {
        let that = $(this)
        that.text('COPIED').addClass('active')
        setTimeout(function () {
            that.text('COPY').removeClass('active')
        }, 3000)
    })
    new ClipboardJS('.copy-box button');
    $('.copy-box button').click(function () {
        let that = $(this)
        that.text('COPIED').addClass('active')
        setTimeout(function () {
            that.text('COPY').removeClass('active')
        }, 3000)
    })

    // 处理第三方悬浮层级
    function handleIndex() {
        const shopifyChat = document.getElementById('dummy-chat-button-iframe') ?? document.getElementById('ShopifyChat');
        const smileFrame = document.getElementById('smile-ui-lite-container')
        smileFrame && (smileFrame.style.zIndex = isMobile() ? '189' : '1000')
        shopifyChat && (shopifyChat.style.zIndex = isMobile() ? '189' : '1000')
    }
    function copyData (){
        let timeId = null;
        $('[data-ug-copy-data]').click(function () {
            clearTimeout(timeId);
            timeId = setTimeout(() => {
                var copyText = $(this).attr('data-ug-copy-data');
                var input = document.createElement('input');
                input.setAttribute('value', copyText);
                document.body.appendChild(input);
                input.select();
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    $(this).text('Copied');
                    setTimeout(() => {
                        $(this).text('Copy');
                    }, 2000)
                }
                document.body.removeChild(input);
            }, 200);
        });
    }
    copyData()
    setTimeout(() => {
        handleIndex()
    }, 5000)

  function productScriptInit() {
     // 选择要观察的目标节点
     var targetNode = document.querySelector(".flickityt4s-slider .t4s-product__media-item:first-child");

     // 配置观察选项
     var config = { attributes: true, attributeFilter: ['class'] };
     // 当观察到变动时执行的回调函数
     var callback = function (mutationsList, observer) {
        for (var mutation of mutationsList) {
           if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              targetNode.className.includes("is-selected") ? $('.sticky-product-wrapper .ug-discount-flag').show() : $('.sticky-product-wrapper .ug-discount-flag').hide()
           }
        }
     };

     // 创建一个观察器实例并传入回调函数
     var observer = new MutationObserver(callback);

     // 开始观察目标节点
     observer.observe(targetNode, config);

     // 停止观察（根据需要调用）
     // observer.disconnect();
  }
  // 在商品详情页执行
  if(window.T4Srequest.page_type === "product" ) {
    productScriptInit()
  }

  window.addEventListener('PandectesEvent_OnInitialize', function(event) {
    const cookie_setting_btns = document.querySelectorAll("a[href='#reopenBanner']")
    cookie_setting_btns.forEach(item => {
        item?.addEventListener("click", (event) => {
            event.preventDefault();
            // 打开 cookie 设置
            // Pandectes.fn.showBanner()
            Pandectes.fn.openPreferences()
          })
    })
  })
})
